import type { OrganizationState, State } from '../../types';

export function getOrganization(state: State): OrganizationState | undefined {
  return state.organization;
}
